import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_LISTING_SEND_QUESTION_EMAIL,
} from 'api/actionTypes';

export default async function sendQuestionEmail({ state, apiClient }, { listingId, question }) {
  typeCheck('listingId::PositiveNumber', listingId);
  typeCheck('question::NonEmptyString', question);

  return apiClient.postWithState({
    action: SR_API_ACTION_LISTING_SEND_QUESTION_EMAIL,
    state: state,
    payload: {
      listingId, question,
    },
  });
}
